import { useField, useFormikContext } from "formik";
import { RenderContainer } from "../RenderContainer";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Renderer, Renderer2, RendererProps } from "../model";
import _ from "lodash";
import getUserLocale from "get-user-locale";
import { parseExistingDate } from "components/DateTimeFieldV2/DateTimeFieldV2";
import { parseListDate } from "helpers/parseListDate";

const CustomDate: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
}) => {
  const locale = getUserLocale();
  const [focus, setFocus] = useState<boolean>(false);
  const [dateValue, setDateValue] = useState<Date | null>(null);
  const [readOnlyDate, setReadOnlyDate] = useState<string | null>(null);
  const { setFieldValue } = useFormikContext();
  const [{ value }] = useField(field.name);

  useEffect(() => {
    const selectedDate =
      value[index].value && typeof value[index].value === "string"
        ? parseExistingDate(value[index].value)
        : null;

    if (selectedDate !== dateValue) {
      setDateValue(selectedDate);
    }
    if (value[index].value) {
      const tempReadOnlyDate = parseListDate(
        value[index].value as string,
        true
      );

      if (tempReadOnlyDate !== readOnlyDate) {
        setReadOnlyDate(tempReadOnlyDate);
      }
    }
  }, [value]);

  const handleFocus = () => {
    setFocus(!focus);
  };
  const handleChange = (date: Date | null) => {
    let datepickerDate = date;

    let parsedDate: Date | null = null;

    let parsedDate2: string | null = null;

    const offset = date ? date.getTimezoneOffset() * 60000 : null;

    if (date && offset !== null) {
      const tempDate = new Date(date);

      datepickerDate = tempDate;
      parsedDate = new Date(tempDate.getTime() - offset);
    }

    if (parsedDate) {
      const year = parsedDate.getUTCFullYear();
      const month = parsedDate.getUTCMonth() + 1;
      const day = parsedDate.getUTCDate();
      const hours = parsedDate.getUTCHours();
      const minutes = parsedDate.getUTCMinutes();
      const seconds = parsedDate.getUTCSeconds();

      const yearString = `${year}`;
      let monthString = `${month}`;
      let dayString = `${day}`;
      let hoursString = `${hours}`;
      let minutesString = `${minutes}`;
      let secondsString = `${seconds}`;

      if (month < 10) {
        monthString = `0${month}`;
      }

      if (day < 10) {
        dayString = `0${day}`;
      }

      if (hours < 10) {
        hoursString = `0${hours}`;
      }

      if (minutes < 10) {
        minutesString = `0${minutes}`;
      }
      if (seconds < 10) {
        secondsString = `0${seconds}`;
      }

      parsedDate2 = `${yearString}-${monthString}-${dayString}T${hoursString}:${minutesString}:${secondsString}`;
    }

    if (datepickerDate) {
      setDateValue(datepickerDate);
    }

    if (parsedDate2) {
      const tempValues = _.cloneDeep(value);

      tempValues[index] = { ...tempValues[index], value: parsedDate2 };
      setFieldValue(field.name, [...tempValues]);
    }
    if (date === null) {
      const tempValues = _.cloneDeep(value);
      tempValues[index] = { ...tempValues[index], value: null };
      setFieldValue(field.name, [...tempValues]);
    }
  };
  const clearValue = () => {
    setDateValue(null);
    handleChange(null);
  };
  return (
    <RenderContainer customFieldName={customField.name}>
      {readOnly ? (
        <div className="EditBox ViewOnly">
          {readOnlyDate ? `${readOnlyDate}` : "No date"}
        </div>
      ) : (
        <div
          className="DatePickerContainer"
          onFocus={handleFocus}
          onBlur={handleFocus}
        >
          <DatePicker
            dateFormat="dd-MMM-yyyy"
            locale={locale}
            className={readOnly ? "EditBox ViewOnly" : "EditBox"}
            onChange={handleChange}
            selected={dateValue}
            readOnly={readOnly}
            placeholderText={readOnly ? "" : "Select date and time..."}
            timeFormat="HH:mm:ss"
            showTimeInput
          />
          {!readOnly && dateValue && (
            <svg
              className={`clearDate ${focus ? "Datefocus" : ""}`}
              onClick={clearValue}
            >
              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
            </svg>
          )}
        </div>
      )}
    </RenderContainer>
  );
};

export const customDate: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomDate
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
